import { Navigate } from 'react-router-dom';

import { aiRoutes } from 'src/routes/sections/ai';
import { entityRoutes } from 'src/routes/sections/entity';
import { supervisorRoutes } from 'src/routes/sections/superadmin';

import { PATH_AFTER_LOGIN } from 'src/config-global';

import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { errorRoutes } from './error';

// ----------------------------------------------------------------------

export const allRoutes = [
  {
    path: '/',
    element: <Navigate to={PATH_AFTER_LOGIN()} replace />,
  },
  ...authRoutes,
  ...supervisorRoutes,
  ...aiRoutes,
  ...entityRoutes,
  ...errorRoutes,
  ...mainRoutes,
  { path: '*', element: <Navigate to="/404" replace /> },
];
